import { StorefrontProductSort } from '@/modules/product/types'
import { FilterIdentifier } from '@/types/index'

type FilterSelection<T> = {
  sort: T
  filters: FilterIdentifier[]
  priceRangeFilter?: PriceRangeFilter
}

type ProductFilterSelection = FilterSelection<StorefrontProductSort> & {
  priceRangeFilter: PriceRangeFilter
  stockCountFilter: number | undefined
}

type PriceRangeFilter = {
  start?: number
  end?: number
}

const DEFAULT_FILTER_TERM = 'ARCNOTARCHIVED'
const PRICE_RANGE_FILTER_PREFIX = 'PRR'
const STOCK_COUNT_FILTER_PREFIX = 'STK'

export {
  FilterSelection,
  ProductFilterSelection,
  PriceRangeFilter,
  DEFAULT_FILTER_TERM,
  PRICE_RANGE_FILTER_PREFIX,
  STOCK_COUNT_FILTER_PREFIX
}
